import { useEffect, useState } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function InstallPrompt() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null);
  const [visible,  setVisible]  = useState(false);

  useEffect(() => {
    const onPrompt = (e: Event) => {
      e.preventDefault();
      const dismissed = localStorage.getItem('professya_install_dismissed');
      if (!dismissed) {
        setDeferred(e as BeforeInstallPromptEvent);
        setVisible(true);
      }
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (!visible || !deferred) return null;

  async function install() {
    if (!deferred) return;
    await deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === 'dismissed') {
      localStorage.setItem('professya_install_dismissed', '1');
    }
    setVisible(false);
  }

  function dismiss() {
    localStorage.setItem('professya_install_dismissed', '1');
    setVisible(false);
  }

  return (
    <div
      role="dialog"
      aria-label="Instalar o Professya"
className="fixed bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-sm bg-[#0D1130] border border-[#C9A84C] p-4 rounded-sm shadow-2xl"
style={{ zIndex: 200, bottom: 'calc(1.5rem + env(safe-area-inset-bottom, 0px))' }}    >
      <p className="text-[#F5ECD7] text-sm mb-3 leading-relaxed">
        Instale o Professya no seu celular para acesso rápido e notificações na hora certa.
      </p>
      <div className="flex gap-3">
        <button
          onClick={install}
          className="px-4 py-2 bg-[#C9A84C] text-[#0D1130] text-xs tracking-[2px] uppercase font-bold hover:bg-[#C9A84C]/90 transition-colors"
        >
          Instalar
        </button>
        <button
          onClick={dismiss}
          className="px-4 py-2 text-[#F5ECD7]/60 text-xs uppercase tracking-wider hover:text-[#F5ECD7] transition-colors"
        >
          Agora não
        </button>
      </div>
    </div>
  );
}
